<template>
  <div class="calling_partner_wrapper">
    <div id="me"></div>
    <div id="remote-container"></div>
    <div class="top_header">
      <!-- <h2>Prachi Jain</h2> -->
      <div class="logout_block" v-if="!(callStatus === 'call_initiate')">
        <span class="logout_btn" @click="handleLogout">Logout</span>
      </div>
    </div>
    <div class="profile_sec">
      <span class="profile_icon"></span>
    </div>
    <!-- <div class="name_block">
      <p>Prachi Jain</p>
      <p>saharanpur</p>
    </div> -->
    <div class="loader" v-if="callStatus === 'initial'">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>

    <div class="contact_content">
      <p v-if="callStatus === 'initial'">साथी की तलाश में...</p>
      <div class="call-duration" v-if="callStatus === 'call_initiate'">
        <label id="minutes">{{ Minutes }}</label
        >:<label id="seconds">{{ Seconds }}</label>
      </div>
    </div>

    <div class="volume_buttons" v-if="callStatus === 'call_initiate'">
      <div class="speaker_icon_block">
        <span
          :class="!micOn ? 'speaker_icon' : 'speaker_icon active'"
          @click="handleMic"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="19"
            viewBox="0 0 14 19"
          >
            <g transform="translate(-5 -2)">
              <path
                class="a"
                d="M12,14a2.987,2.987,0,0,0,2.99-3L15,5A3,3,0,0,0,9,5v6A3,3,0,0,0,12,14ZM10.8,4.9a1.2,1.2,0,1,1,2.4,0l-.01,6.2a1.2,1.2,0,1,1-2.39,0V4.9ZM17.3,11A5.189,5.189,0,0,1,12,16.1,5.189,5.189,0,0,1,6.7,11H5a6.984,6.984,0,0,0,6,6.72V21h2V17.72A6.968,6.968,0,0,0,19,11Z"
              />
            </g>
          </svg>
        </span>
      </div>
      <div class="speaker_icon_block">
        <span :class="speakerOn ? 'speaker_icon active': 'speaker_icon'" @click="handleSpeaker">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="17.54"
            viewBox="0 0 18 17.54"
          >
            <g transform="translate(-3 -3.23)">
              <path
                class="a"
                d="M3,9v6H7l5,5V4L7,9Zm13.5,3A4.5,4.5,0,0,0,14,7.97v8.05A4.474,4.474,0,0,0,16.5,12ZM14,3.23V5.29a7,7,0,0,1,0,13.42v2.06A8.994,8.994,0,0,0,14,3.23Z"
              />
            </g>
          </svg>
        </span>
      </div>
    </div>

    <!-- <div class="speaker_icon_block">
        <span class="speaker_icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="17.54"
            viewBox="0 0 18 17.54"
          >
            <g transform="translate(-3 -3.23)">
              <path
                class="a"
                d="M3,9v6H7l5,5V4L7,9Zm13.5,3A4.5,4.5,0,0,0,14,7.97v8.05A4.474,4.474,0,0,0,16.5,12ZM14,3.23V5.29a7,7,0,0,1,0,13.42v2.06A8.994,8.994,0,0,0,14,3.23Z"
              />
            </g>
          </svg>
        </span>
      </div> -->
    0
    <div class="cancel_btn_block">
      <span class="cancel_btn" v-if="accepted" @click="callReject">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37.923"
          height="14"
          viewBox="0 0 37.923 14"
        >
          >
          <g transform="translate(0 -14)">
            <path
              class="a"
              d="M18.962,17.16A23.524,23.524,0,0,0,11.693,18.3V23.2a1.592,1.592,0,0,1-.885,1.422A18.331,18.331,0,0,0,6.6,27.55,1.578,1.578,0,0,1,5.491,28a1.545,1.545,0,0,1-1.114-.466L.466,23.623a1.583,1.583,0,0,1,0-2.244,26.868,26.868,0,0,1,36.991,0,1.563,1.563,0,0,1,.466,1.122,1.545,1.545,0,0,1-.466,1.114l-3.911,3.911a1.574,1.574,0,0,1-2.22.016,18.331,18.331,0,0,0-4.211-2.923A1.592,1.592,0,0,1,26.23,23.2V18.29A23.758,23.758,0,0,0,18.962,17.16Z"
              transform="translate(0 0)"
            />
          </g>
        </svg>
      </span>
      <!-- <span v-if="accepted" class="cancel_btn receive_btn" >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37.923"
          height="14"
          viewBox="0 0 37.923 14"
        >
          >
          <g transform="translate(0 -14)">
            <path
              class="a"
              d="M18.962,17.16A23.524,23.524,0,0,0,11.693,18.3V23.2a1.592,1.592,0,0,1-.885,1.422A18.331,18.331,0,0,0,6.6,27.55,1.578,1.578,0,0,1,5.491,28a1.545,1.545,0,0,1-1.114-.466L.466,23.623a1.583,1.583,0,0,1,0-2.244,26.868,26.868,0,0,1,36.991,0,1.563,1.563,0,0,1,.466,1.122,1.545,1.545,0,0,1-.466,1.114l-3.911,3.911a1.574,1.574,0,0,1-2.22.016,18.331,18.331,0,0,0-4.211-2.923A1.592,1.592,0,0,1,26.23,23.2V18.29A23.758,23.758,0,0,0,18.962,17.16Z"
              transform="translate(0 0)"
            />
          </g>
        </svg>
      </span> -->
    </div>
    <div class="popOverlaybg" v-if="showPopUp">
      <div class="calling-model">
        <!-- <h2>You are calling..</h2> -->
        <p>
          {{message}}
        </p>
        <br />
        <br />
        <div class="calling">
          <span class="call-icon" @click="callDecline">
            <img src="../../assets/images/cross.svg" />
          </span>
          <span class="call-icon" @click="callAccept" v-if="showPopUpDecline">
            <!-- <img src="../../assets/images/checked.svg" /> -->
          </span>
        </div>
      </div>
    </div>
     <Toaster :dataValue="toasterData"/>
  </div>
</template>
<script>
import VueSocketIO from "vue-socket.io";
import * as io from "socket.io-client";
import {
  removeVideoStream, 
} from "../../utils/helper";
import Toaster from "../../components/common/Toaster";
import { SOCKET_URL, SOCKET_LOCAL_URL } from "../../utils/constant";
import Vue from "vue";
export default {
  name: "PartnerCallingScreen",
  components: {
    Toaster
  },
  data() {
    return {
      loading: false,
      client: {},
      uStreamId: null,
      Seconds: "00",
      Minutes: "00",
      callStatus: "initial",
      remoteStream: {},
      localStream: {},
      timeStamp: null,
      accepted: false,
      showCalling: false,
      showPopUp: false,
      showPopUpDecline: true,
      timeInterval: null,
      micOn: false,
      message: null,
      toasterData: {},
      speakerOn: false,
      speakerMessage: null,
      status: false,
      identifier: null
    };
  },
  computed: {},
  methods: {
    removeVideoStream,
    handleLogout() {
      this.$cookie.set("loginSuccess", null);
      this.$socket.emit("close_operator_room", {
        user_id: this.$route.params.id,
        code: 0
      });
      this.$router.replace("/partner-login");
    },
    handleSpeaker(){
    if(!this.speakerOn){  
        this.remoteStream.setEffectsVolume(80, (err) => {
          if (err) {
            console.error("Failed to set effects volume, reason: ", err);
          } else {
            console.log("Effects volume is set successfully");
            this.speakerOn = true 
            this.toasterData = {
              status: true,
              msg: "Speaker On",
              timeoutMs: "5000",
              color: "#330028"
            };
          }
        });
      }else{
        this.remoteStream.setEffectsVolume(30, (err) => {
          if (err) {
            console.error("Failed to set effects volume, reason: ", err);
          } else {
            console.log("Effects volume is set successfully");
            this.speakerOn = false
            this.toasterData = {
              status: true,
              msg: "Speaker off",
              timeoutMs: "5000",
              color: "#330028"
            };
          }
        });
      }
    },
    handleMic() {
      console.log("===micon==", this.micOn);
      console.log(
        "==localStream===",
        this.localStream.isAudioOn(),
        this.localStream
      );
      this.localStream.isAudioOn()
        ? this.localStream.disableAudio()
        : this.localStream.enableAudio();
      this.toasterData = {
        status: true,
        msg: this.localStream.isAudioOn() ? 'mic off' : 'mic on',
        timeoutMs: "5000",
        color: "#330028"
      };
      this.micOn = !this.micOn;
    },
    callAccept() {
      console.log("====call==accept");
      this.$socket.emit("accept_dost_call", {
        timestamp: this.timeStamp,
        operator_id: this.$route.params.id,
        code: this.identifier
      });
    },
    callDecline() {
      this.showPopUp = false;
      this.$socket.emit("decline_dost_call", {
        timestamp: this.timeStamp,
        operator_id: this.$route.params.id,
        code: this.identifier === 1 ? 2 : 0
      });
    },
    callReject() {
      console.log("====reject====");
      this.$socket.emit("disconnect_dost_call", {
        timestamp: this.timeStamp,
        operator_id: this.$route.params.id,
        code: this.identifier
      });
    },
    countUpCounter() {
      console.log("===countUpCounter===");
      let totalSeconds = 0;
      this.Seconds = "00";
      this.Minutes = "00";
      this.timeInterval = setInterval(() => {
        ++totalSeconds;
        this.Seconds = pad(totalSeconds % 60);
        this.Minutes = pad(parseInt(totalSeconds / 60));
      }, 1000);
      const pad = val => {
        let valString = val + "";
        if (valString.length < 2) {
          return "0" + valString;
        } else {
          return valString;
        }
      };
    },
    startCalling() {
      this.callStatus = 'call_initiate'
      let rt = this;
      let handleFail = function(err) {
        console.log("Error : ", err);
      };
      // The client joins the channel
      rt.client.join( null, rt.room_id, null,  (uid) => {
        console.log("join channel: " + " success, uid: " + uid);
          this.uStreamId = uid
          // Stream object associated with your web cam is initialized
          rt.localStream = AgoraRTC.createStream({
            streamID: uid,
            audio: true,
            video: false,
            screen: false
          });
          // Associates the stream to the client
          rt.localStream.init(()=> {
            rt.client.publish(rt.localStream, handleFail);
        },handleFail)
      })

      //When a stream is added to a channel
      rt.client.on("stream-added", (evt) => {
         rt.remoteStream =  evt.stream
         var id = rt.remoteStream.getId()
         if (id !== this.uStreamId) {
          rt.client.subscribe(rt.remoteStream, handleFail)
        }
      });
      //When you subscribe to a stream
      rt.client.on("stream-subscribed", (evt) => {
        let stream = evt.stream;
        rt.remoteStream = evt.stream;
        console.log('===rt.remoteStream==',rt.remoteStream)
        rt.remoteStream && rt.remoteStream.play("remote-container");
        rt.remoteStream.setAudioVolume(30, function(err) {
          if (err) {
            console.error("Failed to set effects volume, reason: ", err);
          } else {
            console.log("Effects volume is set successfully");
          }
        });
      });

      rt.client.on("onAudioRouteChanged", (evt)=>{
        console.log('===onAudioRouteChanged====',evt)
      })
      //When a person is removed from the stream
      rt.client.on("stream-removed",removeVideoStream);
      // rt.client.on("peer-leave");
      rt.client.on("client-role-changed", function(evt) {
        console.log("client-role-changed", evt.role);
        console.log("client-role-changed", evt);
      });
    }
  },
  mounted() {
    this.$socket.on("disconnect", () => {
      console.log("=run");
    });

    let rt = this;
    // Client Setup
    // Defines a client for RTC
    rt.client = AgoraRTC.createClient({
      mode: "rtc", codec: "h264"
    });
    let handleFail = function(err) {
      console.log("Error : ", err);
    };
    // Client Setup
    // Defines a client for Real Time Communication
    rt.client.init(
      "24d720d21ce748d499e936328229ac26",
      () => console.log("AgoraRTC client initialized"),
      handleFail
    );

  },
  sockets: {
    call_declined: function(data) {
      console.log("==decline call partner==", data);
      this.showPopUp = false;
    },
    disconnect_event: function(data) {
      console.log("====data===", data);
    },
    call_disconnected: function(data) {
      console.log("====disconnect dost call ===partner", data);
      let $ = this;
      $.callStatus = "call_end";
      clearInterval($.timeInterval);
      // $.remoteStream && $.remoteStream.stop()
      $.client.unsubscribe($.remoteStream, function(err) {
        console.log(err);
      });
      // $.remoteStream = null
      $.accepted = false;
      //  $.client && $.client.unpublish($.localStream)
      $.client && $.client.unpublish($.localStream);
      $.localStream && $.localStream.close();
      $.remoteStream && $.remoteStream.close();
      $.client &&
        $.client.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );
    },
    call_received: function(data) {
      let self = this;
      self.countUpCounter();
      console.log("===");
      console.log("===call received===", data);
      self.accepted = true;
      self.showPopUp = false;
      self.startCalling();
    },
    call_initiated_error: function(data) {
      console.log("=call call_initiated_error=---=data=", data);
    },
    call_initiated: function(data) {
      let self = this;
      self.identifier = data.identifier
      // self.countUpCounter()
      self.message = data.message;
      self.room_id = data.room_id;
      self.showNotifyModal = false;
      console.log("=call initiated=---=data=", data.timestamp);
      self.timeStamp = data.timestamp;
      self.showCalling = true;
      self.showPopUp = true;
    }
  }, 
  created() {
    Vue.use(
      new VueSocketIO({
        debug: window.SocketDebug,
        connection: io(SOCKET_URL, {
          query: {
            identifier: "91",
            user_id: this.$route.params.id
          },
          reconnectionDelay: 1000
        })
      })
    );
    console.log("=====", this.$socket);
  },
  beforeDestroy() {
    // this.$store.dispatch({type: 'close_operator_room', payload: {user_id: this.$route.params.id, code: 1}})
    
    // this.$socket.emit("close_operator_room", {
    //   user_id: this.$route.params.id,
    //   code: 0
    // });
    // this.$socket.close();
    if (this.callStatus === "call_initiate") {
      let $ = this;
      $.callReject();
      // $.remoteStream && $.remoteStream.stop()
      $.client.unsubscribe($.remoteStream, function(err) {
        console.log(err);
      });
      // $.remoteStream = null

      //  $.client && $.client.unpublish($.localStream)
      $.client && $.client.unpublish($.localStream);
      $.localStream && $.localStream.close();
      $.remoteStream && $.remoteStream.close();
      $.client &&
        $.client.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );
    }
  }
};
</script>
<style scoped>
/* ****************************callingScreenPartner********************************* */

.calling_partner_wrapper {
  width: 100%;
  height: 100vh;
  /* background: url("../../assets/images/romantic_couple-HD.jpg"); */
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.calling_partner_wrapper .top_header {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 15px;
}

.calling_partner_wrapper .top_header h2 {
  color: #fff;
  font-size: 1.25em;
  font-weight: 600;
}

.logout_block {
  display: flex;
  align-items: center;
}

.calling_partner_wrapper .logout_btn {
  padding: 8px 10px;
  color: #fff;
  background: #ff335d;
  border: none;
  border-radius: 20px;
  font-size: 0.75em;
  font-weight: 600;
}

.calling_partner_wrapper .profile_sec {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.calling_partner_wrapper .profile_sec .profile_icon {
  height: 80px;
  width: 80px;
  background: #4b3d63;
  border-radius: 50%;
  border: 5px solid #6f6979;
}

.name_block {
  text-align: center;
  width: 100%;
  display: block;
}

.name_block p:first-child {
  font-size: 0.875em;
  color: #fff;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.name_block p:last-child {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.625em;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calling_partner_wrapper .contact_content {
  width: 100%;
  text-align: center;
}

.calling_partner_wrapper .contact_content p {
  color: #fff;
  font-size: 1em;
}

.call_btn_block .receive_btn {
  background: #0ebf4e;
}
</style>
